var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoLsHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 20,
    viewBox: "0 0 126 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6849 2.19922H25.4745C20.1258 2.19922 17.7226 5.76253 17.7226 8.30258C17.7226 10.8426 19.7806 12.8065 25.093 12.8065L26.1778 12.8116C27.3482 12.8116 27.9996 12.9744 28.0178 13.7548C28.0256 14.1837 27.7323 14.685 27.4157 14.9305C26.702 15.4809 26.0714 15.5377 22.7106 15.5377H6.1272L9.32969 2.21472H3.78892C3.4178 2.21472 3.28026 2.32067 3.17126 2.75994L0.132268 15.2457C-0.438678 17.7289 0.84595 20.0003 3.71625 20.0003H11.3228C13.2485 20.0003 15.8281 17.9046 16.874 15.9692C16.9311 15.8607 16.9674 15.7935 17.0115 15.7057C17.0115 15.7057 17.0349 15.6773 17.0401 15.716C16.874 16.4137 16.29 18.8711 16.1966 19.2742C16.0746 19.7961 16.3471 19.9951 16.5989 19.9951H24.7816C31.7211 19.9951 34.4305 16.7057 34.6693 12.7574C34.8017 10.5377 33.3925 9.10361 29.4062 9.10361H26.3439C25.2539 9.10361 24.138 8.74702 24.138 7.86847C24.138 6.98992 25.3525 6.22247 26.9927 6.22247H34.4435C34.4435 6.22247 35.0949 3.62299 35.2247 3.08036C35.3856 2.39819 35.1806 2.19922 34.6797 2.19922",
    fill: "#003378"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9973 3.89922L44.6246 0H29.8008C29.8008 0 36.2213 1.30233 36.7923 1.41602C37.3658 1.5323 37.4956 1.83721 37.397 2.24031C37.3061 2.62016 36.9973 3.89664 36.9973 3.89664",
    fill: "#E6003E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8671 13.1768L74.1396 12.0734C74.3031 11.4455 73.8982 11.1406 73.4882 11.1406H64.7034C64.2207 11.1406 64.1065 11.2621 64.0053 11.6781L62.4871 17.9572L62.2483 18.9417C62.0952 19.5024 62.2328 19.9933 62.9568 19.9933H71.4925C72.175 19.9933 72.4916 19.5644 72.6318 19.0579L72.8991 17.9572H64.9448L65.2951 16.5076H70.8722C71.5548 16.5076 71.8714 16.0786 72.0115 15.5721L72.2788 14.4714H65.7882L66.1022 13.1768H73.8723H73.8671Z",
    fill: "url(#paint0_linear_20663_12732)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3919 11.1406H53.5052C53.025 11.1406 52.9083 11.2621 52.807 11.6781L51.0501 18.9442C50.897 19.505 51.0345 19.9959 51.7586 19.9959H60.1956C60.8781 19.9959 61.1948 19.567 61.3349 19.0605L61.6022 17.9597H53.7439L55.3919 11.1432V11.1406Z",
    fill: "url(#paint1_linear_20663_12732)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.31 11.1432H119.362C116.974 11.1432 115.643 12.0709 115.082 14.2931L114.56 16.4429C114.14 18.3267 114.646 19.9959 117.257 19.9959H123.41C124.093 19.9959 124.409 19.567 124.547 19.0605L124.814 17.9597H118.175C117.031 17.9597 116.808 17.4042 116.987 16.5566L117.42 14.7246C117.719 13.5515 118.728 13.1768 119.564 13.1768H125.691L125.964 12.0734C126.127 11.4455 125.722 11.1406 125.312 11.1406L125.31 11.1432Z",
    fill: "url(#paint2_linear_20663_12732)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.798 11.1432H78.8498C76.4622 11.1432 75.1309 12.0709 74.5703 14.2931L74.0486 16.4429C73.6282 18.3267 74.1343 19.9959 76.7451 19.9959H82.8983C83.5809 19.9959 83.8975 19.567 84.035 19.0605L84.3023 17.9597H77.6638C76.5193 17.9597 76.2961 17.4042 76.4752 16.5566L76.9086 14.7246C77.207 13.5515 78.2166 13.1768 79.0522 13.1768H85.1769L85.4494 12.0734C85.6129 11.4455 85.2081 11.1406 84.798 11.1406V11.1432Z",
    fill: "url(#paint3_linear_20663_12732)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.574 11.1406H111.737L109.842 18.9442C109.689 19.505 109.827 19.9959 110.551 19.9959H112.31L114.225 12.076C114.389 11.4481 113.984 11.1432 113.574 11.1432V11.1406Z",
    fill: "url(#paint4_linear_20663_12732)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9197 12.0734C98.0832 11.4455 97.6784 11.1406 97.2683 11.1406H87.0925C86.6124 11.1406 86.4956 11.2621 86.3944 11.6781L86.0259 13.1768H90.5078L89.1116 18.9442C88.9585 19.505 89.096 19.9959 89.8201 19.9959H91.4602L93.1082 13.1794H97.6498L97.9223 12.076L97.9197 12.0734Z",
    fill: "url(#paint5_linear_20663_12732)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.609 11.1406H99.5574C99.0773 11.1406 98.9605 11.2621 98.8593 11.6781L97.0945 18.9442C96.9414 19.505 97.079 19.9959 97.803 19.9959H99.2979L100.946 13.1794H106.141C107.849 13.1794 107.473 15.5411 105.464 15.5411H101.722C101.351 15.5411 101.211 15.9184 101.46 16.1871L102.742 17.5773L104.335 19.3034C104.836 19.8641 104.968 19.9985 105.692 19.9985H108.194L105.864 17.5618C110.421 17.2388 111.467 11.1458 106.609 11.1458V11.1406Z",
    fill: "url(#paint6_linear_20663_12732)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2705 8.83984H40.1941C39.5868 8.83984 39.4415 8.9923 39.3143 9.51685L37.3991 17.4342L37.0954 18.6745C36.9008 19.3825 37.0773 20 37.9882 20H48.7479C49.6095 20 50.0066 19.46 50.1831 18.8218L50.4478 17.7417H40.1007L40.6171 15.6047H47.9642C48.8258 15.6047 49.2229 15.0646 49.3993 14.4264L49.7367 13.0388H41.2374L41.7071 11.0982H51.8207L52.088 10.0156C52.293 9.22486 51.7817 8.83984 51.2653 8.83984H51.2705Z",
    fill: "url(#paint7_linear_20663_12732)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20663_12732",
    x1: 68.5106,
    y1: 19.8021,
    x2: 68.5106,
    y2: 11.0941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20663_12732",
    x1: 56.3023,
    y1: 19.8421,
    x2: 56.3023,
    y2: 12.7891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20663_12732",
    x1: 120.219,
    y1: 19.8421,
    x2: 120.219,
    y2: 12.7891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20663_12732",
    x1: 79.7063,
    y1: 19.8421,
    x2: 79.7063,
    y2: 12.7891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20663_12732",
    x1: 112.026,
    y1: 19.8421,
    x2: 112.026,
    y2: 12.7891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_20663_12732",
    x1: 91.996,
    y1: 19.8421,
    x2: 91.996,
    y2: 12.7891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_20663_12732",
    x1: 103.424,
    y1: 19.8447,
    x2: 103.424,
    y2: 12.7896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_20663_12732",
    x1: 44.5852,
    y1: 19.8063,
    x2: 44.5852,
    y2: 10.9174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003378"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLsHeader);
export default __webpack_public_path__ + "static/media/logo_ls_header.28a6bac73265a25a167c48af370ca968.svg";
export { ForwardRef as ReactComponent };